const FaqsCategoryIndex = () => import('./views/FaqsCategoryIndex.vue')
const FaqsCategoryCreate = () => import('./views/FaqsCategoryCreate.vue')
const FaqsCategoryEdit = () => import('./views/FaqsCategoryEdit.vue')

export default [
  {
    path: 'faqs/categories',
    name: 'faqs.categories.index',
    component: FaqsCategoryIndex
  },
  {
    path: 'faqs/categories/create',
    name: 'faqs.categories.create',
    component: FaqsCategoryCreate
  },
  {
    path: 'faqs/categories/:categoryId',
    name: 'faqs.categories.edit',
    component: FaqsCategoryEdit
  }
]
